<mat-card appearance="outlined" class="mt2 card-padding">
  <mat-card-header class="flex justify-start content-start items-start flex-col">
    <mat-card-title>
      <span>{{title()}}</span>
    </mat-card-title>
    <div class="flex flex-row justify-start content-center items-center w-full">
      <mat-checkbox color="primary" (change)="$event ? masterToggle() : null" [checked]="matSelectionList.selectedOptions.selected.length > 0 && isAllSelected()" [indeterminate]="matSelectionList.selectedOptions.selected.length > 0 && !isAllSelected()">
      </mat-checkbox>
      <div class="mt2 flex flex-row items-center flex-wrap">
        @if (objectSearch() === true) {
          @if (type() === 'Building') {
            <mat-form-field floatLabel="never" class="filter-field ml2">
              <input type="text" [placeholder]="'Building' | translate" matInput="" [formControl]="buildingFormControl" [matAutocomplete]="buildingAutocomplete" autocomplete="off">
              <mat-autocomplete autoActiveFirstOption="" #buildingAutocomplete="matAutocomplete" [displayWith]="displayBuilding">
                @for (building of buildingsFiltered | async; track building) {
                  <mat-option [value]="building">
                    {{building.address.addressLine1}}, {{building.address.city}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
          @if (type() === 'Mortgage') {
            <mat-form-field floatLabel="never" class="filter-field ml2">
              <input type="text" [placeholder]="'Ongoing mortgage' | translate" matInput="" [formControl]="mortgageFormControl" [matAutocomplete]="mortgageAutocomplete" autocomplete="off">
              <mat-autocomplete autoActiveFirstOption="" #mortgageAutocomplete="matAutocomplete" [displayWith]="displayMortgage">
                @for (mortgage of mortgagesFiltered | async; track mortgage) {
                  <mat-option [value]="mortgage">
                    {{(mortgage.number || "...") + " - " + mortgage.lender?.name}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
          @if (type() === 'Application') {
            <mat-form-field floatLabel="never" class="filter-field ml2">
              <input type="text" [placeholder]="'Application' | translate" matInput="" [formControl]="applicationFormControl" [matAutocomplete]="applicationAutocomplete" autocomplete="off">
              <mat-autocomplete autoActiveFirstOption="" #applicationAutocomplete="matAutocomplete" [displayWith]="displayApplication">
                @for (application of applicationsFiltered | async; track application) {
                  <mat-option [value]="application">
                    {{application.name}} - {{application.mortgage?.lender?.name}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
        }
        @if (type() !== 'Other') {
          <mat-form-field floatLabel="never" class="filter-field filter-field-big ml2">
            <input type="text" [placeholder]="'All document types' | translate" matInput="" [formControl]="documentTypeFormControl" [matAutocomplete]="documentTypeAutocomplete" autocomplete="off">
            <mat-autocomplete autoActiveFirstOption="" #documentTypeAutocomplete="matAutocomplete" [displayWith]="displayDocumentType">
              <mat-option [value]="null"><span translate="">All</span></mat-option>
              @for (documentType of documentTypesFiltered | async; track documentType) {
                <mat-option [value]="documentType">
                  <span class="small gray">{{documentType.id}}.</span>&nbsp;{{documentType.name}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        <mat-form-field floatLabel="never" class="filter-field ml2">
          <mat-select [formControl]="uploadYearFormControl" [placeholder]="'Upload year' | translate">
            <mat-option [value]="null"><span translate="">All</span></mat-option>
            @for (year of years; track year) {
              <mat-option [value]="year">
                {{ year }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content style="min-height: 200px">
    <mat-selection-list class="document-list" color="primary">
      @for (document of documents; track document) {
        <mat-list-option checkboxPosition="before" [value]="document">
          <unite-file-row class="document-list-item flex justify-start content-center items-center flex-row flex-wrap" (downloadDocument)="downloadDocument($event)" (showEdit)="showEdit($event)" (openDocument)="openDocument($event)" [document]="document" [linkText]="getLinkText(document)" [fileExtension]="getFileExtension(document.originalFileName)">
          </unite-file-row>
        </mat-list-option>
      }
    </mat-selection-list>

    @if (documentsLoading === false && documentsLength === 0) {
      <div class="empty">
        <p translate="">Nothing found</p>
      </div>
    }

    @if (documentsLoading) {
      <div class="loader table-loader">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    }
  </mat-card-content>
  <mat-card-footer>
    <div class="flex justify-between content-center items-center flex-row gap-[1.5rem]">

      <div class="flex flex-row justify-start content-center items-center h-full gap-[1.5rem]">
        <button [disabled]="getSelectedDocuments().length === 0 || getSelectedDocuments().length > 30" mat-stroked-button="" color="primary" (click)="downloadSelectedDocuments()">
          <mat-icon class="mr1">get_app</mat-icon>
          <span translate="" matTooltipClass="tooltip-info" matTooltip="Er kunnen maar maximaal 30 bestanden tegelijk worden gedownload." [matTooltipDisabled]="getSelectedDocuments().length <= 30">Download documents</span>
        </button>

        <button [disabled]="getSelectedDocuments().length === 0" mat-stroked-button="" color="primary" (click)="linkSelectedDocumentsToApplication()">
          <mat-icon class="mr1">edit</mat-icon>
          <span translate="">Link to application</span>
        </button>
      </div>

      <mat-paginator class="ml-auto" [length]="documentsLength" [pageSizeOptions]="[15, 30, 50, 100]" (page)="pageChange($event)" showFirstLastButtons="">
      </mat-paginator>
    </div>
  </mat-card-footer>
</mat-card>